import { en } from './en';

export const loc = en;
